import * as Blockly from "blockly";

export class FieldMultilineModalBase extends Blockly.FieldTextInput {
  public static SERIALIZABLE = true;
  public override SERIALIZABLE = true;

  public static override fromJson<T extends FieldMultilineModalBase>(
    this: new (value?: string) => T,
    options: Blockly.FieldConfig & { text?: string },
  ): T {
    const text = Blockly.utils.parsing.replaceMessageReferences(
      options.text ?? "",
    );
    return new this(text);
  }

  constructor(value: string = "") {
    super(value);
  }

  protected override getDisplayText_(): string {
    const value = this.getValue() ?? "";
    if (!value) return "";
    const lines = value.split("\n");
    if (lines.length > 1) {
      const first = lines[0] ?? "";
      const firstLine = first.length > 30
        ? `${first.substring(0, 30)}…`
        : first;
      return `${firstLine} [+${String(lines.length - 1)} Zeilen]`;
    }
    return value.length > 50 ? `${value.substring(0, 50)}…` : value;
  }
}
